import React from 'react';
import { Alert, Snackbar } from '@mui/material';

function SnackbarDisplayErrors({ errors, onCloseSnackbar }) {
  return (
    <div>
      {errors && (
      <Snackbar
        open={errors.length > 0}
        autoHideDuration={10000}
        onClose={onCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <div>
          {errors.map((error, index) => (
            <Alert key={index} severity="error">
              {error}
            </Alert>
          ))}
        </div>
      </Snackbar>
      )}
    </div>
  );
}

export default SnackbarDisplayErrors;
